import styled from 'styled-components';

export const PlansContainer = styled.section`
  background-color: ${({ theme }) => theme.elsie.colors.canvas.faint};
  padding: ${({ theme }) => theme.elsie.dimension[80]} ${({ theme }) => theme.elsie.dimension[64]};
`;

export const PlansTitle = styled.h2`
  font-size: ${({ theme }) => theme.elsie.fontSize['2xl']};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.sm};
  letter-spacing: -0.32px;
  margin: 0;
  color: ${({ theme }) => theme.elsie.colors.content.accent};
`;

export const PlansSubtitle = styled.p`
  font-size: ${({ theme }) => theme.elsie.fontSize.md};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: -0.32px;
  margin: ${({ theme }) => theme.elsie.dimension[12]} 0 ${({ theme }) => theme.elsie.dimension[32]};
  color: ${({ theme }) => theme.elsie.colors.content.subtle};
`;

export const PlanCardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${({ theme }) => theme.elsie.dimension[20]};
  align-items: center;
`;

export const PlanCardBenefitList = styled.ul`
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[8]};
  color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  font-size: 15px;
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  list-style-type: none;
  padding: 0;
`;

export const PlanCardBenefit = styled.li`
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  display: flex;
  & strong {
    font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
  }
  ::before {
    content: url('/images/default-landing-page/check.svg');
    display: block;
    margin-right: 12px;
  }
`;

export const PlanCardBenefitHighlight = styled.p`
  margin: 0 0 8px;
  color: ${({ theme }) => theme.elsie.colors.interactive.accent.hovered};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.bold};
`;
